'use strict';

import WebRTCController from './webRTCController';
import AgoraWebRTCController from './AgoraWebRTCController';
import AudioConferenceService from './service';

class AudioConferenceController {
    constructor() {
        {
            this.menu = undefined;
            this._feature = undefined;
            this.service = new AudioConferenceService();
        }

        {
            this.controller = undefined;
        }

        {
            this.controllerType = {
                WebRTC: "webRTC",
                Agora: "agora"
            }
        }

        this.addCustomEvents();

        {
            this.audioBasePath = 'sounds';
            this.joinedNotificationFileName = this.audioBasePath + "\\" + 'joinedConference.mp3';
            this.leftNotificationFileName = this.audioBasePath + "\\" + 'leftConference.mp3';
            this.notificationVolume = 20.0;
            this.notificationProperty = {
                JOINED: {
                    source: this.joinedNotificationFileName,
                    volume: this.notificationVolume,
                    loop: false,
                    shouldStopCurrentlyPlayingNotificationAudio: true,
                },
                LEFT: {
                    source: this.leftNotificationFileName,
                    volume: this.notificationVolume,
                    loop: false,
                    shouldStopCurrentlyPlayingNotificationAudio: true,
                }
            };

            this.notificationController = {
                JOINED: new NotificationAudioController(this.notificationProperty.JOINED),
                LEFT: new NotificationAudioController(this.notificationProperty.LEFT),
            };

            this.NotificationTypeEnum = {
                LEFT: 0,
                JOINED: 1,
            }
        }
    }

    initConferenceController(settingData) {
        if (settingData.type === this.controllerType.Agora) {
            this.controller = new AgoraWebRTCController();
        } else {
            this.controller = new WebRTCController();
        }
    }

    setFeature(feature) {
        this._feature = feature;
    }

    addCustomEvents() {
        let self = this;

        document.addEventListener('canvas.addUser', function (event) {
            self.addUserInCanvas(event.detail.userId);
        });

        document.addEventListener('canvas.removeUser', function (event) {
            self.removeUserFromCanvas(event.detail.userId);
        });

        document.addEventListener('canvas.updateStatus', function (event) {
            self.updateConferenceStatus(event.detail.conferenceStatus);
        });
    }

    addUserInCanvas(userId) {
        this._feature.addUser(userId);
    }

    removeUserFromCanvas(userId) {
        this._feature.removeUser(userId);
    }

    updateConferenceStatus(value) {
        this._feature.updateConferenceStatus(value);
    }

    initMenu(controller, prop, isPresenter) {
        if (!this.menu) {
            this.menu = new MenuData(AudioConferenceMenu.text, 3, 4);
            wv.audioConferenceMenuController = new MenuController(this.menu);
        }

        parseChildrenItems(wv.audioConferenceMenuController, prop.children, menuItemMaps.audioConferenceMenuItemMap);

        this.menu.isVisible = prop.isVisible;
        this.menu.isPresenter = prop.isPresenter;
        this.menu.isViewer = prop.isViewer;

        controller.appendMenuItem(AudioConferenceMenu.menuItemName, prop.text || AudioConferenceMenu.text, this.menu);
        this.addEventsFor2DMenu();
    }

    addEventsFor2DMenu() {
        let self = this;
        document.addEventListener('call.enabled', function () {
            self.initConference(!wv.effectController.audioConferenceEnabled);
        });

        document.addEventListener('speaker.enabled', function () {
            self.callControllerFunction('muteAudio', !wv.effectController.audioEnabled);
        });

        document.addEventListener('mute.enabled', function () {
            self.callControllerFunction('muteMicrophone', !wv.effectController.microphoneDisabled);
        });

        document.addEventListener('muteAll.enabled', function () {
            self.service.muteAllMicrophone();
        });

        document.addEventListener('stopConference.enabled', function () {
            self.endConference();
        });
    }

    initConference(initialize) {
        this.callControllerFunction('initializeConference', initialize);

        if (initialize) {
            this.service.initCall();
        } else {
            this.service.endCall();
        }
    }

    endConference() {
        if (wv.effectController.audioConferenceEnabled) {
            this.updateConferenceMenuStatus(false);
        }

        this.service.endConference();
    }

    askForConferencePermission() {
        wv.promptWindow3dObject.changeText('Do you want to join the audio conference?', "Yes", "No");
        wv.promptWindow3dObject.askNow(this.onPermissionForConference.bind(this));
    }

    updateConferenceMenuStatus(value) {
        wv.effectController.audioConferenceEnabled = value;
        checkBoxSyncVR('webRTCInit', value);
        updateParticipantConferenceInfo(wv.registeredID.toString(), value);
    }

    onPermissionForConference(value) {
        this.service.acceptCall(value);
        this.callControllerFunction('onPermissionForConference', value);
    }

    endConnection(userIdStr) {
        this.callControllerFunction('endConnectionOfThisUser', userIdStr);
    }

    muteMicrophone(value) {
        this.callControllerFunction('muteMicrophone', value);
    }

    updateCanvasLocation() {
        this._feature.updateCanvasLocation();
    }

    callControllerFunction(functionName, ...params) {
        if (typeof this.controller[functionName] === 'function') {
            this.controller[functionName](...params);
        }
    }

    playNotification(notificationType) {
        switch (notificationType) {
            case this.NotificationTypeEnum.JOINED:
                this.notificationController.JOINED.play();
                break;
            case this.NotificationTypeEnum.LEFT:
                this.notificationController.LEFT.play();
                break;
            default:
                break;
        }
    }
}

export default AudioConferenceController;
